var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6332 16.8913H20.2352V2.34783C20.2352 1.95652 19.9174 1.56522 19.4726 1.56522H16.1046C15.7233 1.56522 15.3421 1.8913 15.3421 2.34783V16.9565H14.1347V6.65217C14.1347 6.26087 13.8169 6 13.4992 6H9.877C9.49572 6 9.24153 6.32609 9.24153 6.65217V16.8913H8.03414V10.3696C8.03414 10.1087 7.77995 9.84783 7.52576 9.84783H3.71293C3.45875 9.84783 3.20456 10.1087 3.20456 10.3696V16.8913H1.17105V0.521739C1.17105 0.195652 0.916862 0 0.662674 0C0.344938 0 0.154297 0.26087 0.154297 0.521739V17.4783C0.154297 17.8043 0.408485 18 0.662674 18H21.6332C21.9509 18 22.1416 17.7391 22.1416 17.4783C22.2051 17.1522 21.9509 16.8913 21.6332 16.8913Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartIcon);
export default __webpack_public_path__ + "static/media/ChartIcon.07726e59c19bf30ff9fb6dadfab220f7.svg";
export { ForwardRef as ReactComponent };